import React from 'react';
import { TableInstance } from 'react-table';

import { nameof } from '@work4all/data/lib/helper/nameof';

import { RaPayment } from '@work4all/models/lib/Classes/RaPayment.entity';
import { RaViewModel } from '@work4all/models/lib/Classes/RaViewModel.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTable, IEntityTable } from '../entity-table/EntityTable';
import { useEntityDataTable } from '../entity-table/use-entity-data-table';
import schema from '../schemata/raPayment-table-schema.json';
import { ITableProps } from '../table/Table';

const defaultSort = [{ field: 'id', direction: SortDirection.DESCENDING }];

const RA_PAYMENT_FORCE_REQUEST_FIELDS: RaPayment<EMode.query> = {
  ledgerAccountId: null,
  sachkontoCode: null,
  userId: null,
};

export const RaPaymentsTable = React.forwardRef<TableInstance, IEntityTable>(
  function RaPaymentsTable(_props, ref) {
    const dataTable = useEntityDataTable<RaPayment, never>({
      schema: schema as never,
      defaultSort,
      innerEntityQuery: {
        parentEntity: Entities.raViewModel,
        fieldName: nameof<RaViewModel>('payments'),
      },
      forceRequestFields: RA_PAYMENT_FORCE_REQUEST_FIELDS,
    });

    const overrides: Partial<ITableProps> = {
      layout: 'table',
      areas: null,
      hideSearch: true,
      cardConfig: null,
      selectableMultiple: false,
      displayFooter: false,
      actions: {
        groupingEnabled: null,
      },
    };

    return <EntityTable ref={ref} {...dataTable} overrides={overrides} />;
  }
);
